import React, { useState, useEffect } from 'react'
import Script from 'next/script'
import { BaseLayout } from 'src/layouts'
import { useAppIntl } from 'src/i18n'
import { useNewsletters } from 'src/state'
import styles from './styles.module.scss'
import { Sidebar } from './components/Sidebar'
import { Main } from './components/Main'
import { Header } from './components/Header'
import { Footer } from './components/Footer'
import useWidth from 'src/hooks/useWidth'
import { WEBISTE, WEBSITE } from 'src/consts'
import { Button } from 'src/360ui'
import Image from 'next/image'

const groupByYearAndMonth = newsletters => {
  if (!newsletters) {
    return []
  }
  const grouped = newsletters.reduce((acc, curr) => {
    const [year] = curr.attributes.date.split('-')
    const date = new Date(curr.attributes.date)
    const month = date.toLocaleString('default', { month: 'long' })
    if (!acc[year]) acc[year] = {}
    if (!acc[year][month]) acc[year][month] = []
    acc[year][month].push(curr.attributes)
    return acc
  }, {})

  return Object.entries(grouped)
    .map(([year, months]) => ({
      year,
      months: Object.entries(months).map(([month, newsletters]) => ({
        month,
        newsletters,
      })),
    }))
    .reverse()
}

export const Newsletter = ({ serverNewsletters }) => {
  const newsletters = useNewsletters().data || serverNewsletters
  const ns = groupByYearAndMonth(newsletters)

  const [dataFilter, setDataFilter] = useState([])
  const [search, setSearch] = useState('')
  const [yearFilter, setYearFilter] = useState('All')
  const { getWidth } = useWidth()
  const [monthActive, setMonthActive] = useState('')

  const [headerLoaded, setHeaderLoaded] = useState(false)

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  const resetFilters = () => {
    setDataFilter(ns)
    setSearch('')
    setYearFilter('All')
  }

  useEffect(() => {
    if (
      newsletters &&
      newsletters.length > 0 &&
      dataFilter.length === 0 &&
      search === ''
    ) {
      setDataFilter(ns)
    }
  }, [newsletters, ns, dataFilter, search])
  const intl = useAppIntl()
  return (
    <>
      <div className={styles.header}>
        <Header setHeaderLoaded={setHeaderLoaded} />
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.content}>
          {getWidth > 768 && (
            <div className={styles.sidebar}>
              <Sidebar
                newsletters={ns}
                setDataFilter={setDataFilter}
                setSearch={setSearch}
                yearFilter={yearFilter}
                setYearFilter={setYearFilter}
                monthActive={monthActive}
                setMonthActive={setMonthActive}
                resetFilters={resetFilters}
              />
            </div>
          )}
          <div className={styles.main}>
            <Main
              newsletters={ns}
              setDataFilter={setDataFilter}
              search={search}
              setSearch={setSearch}
              dataFilter={dataFilter}
              yearFilter={yearFilter}
              setYearFilter={setYearFilter}
              getWidth={getWidth}
              resetFilters={resetFilters}
            />
          </div>
        </div>
        <div className={styles.topButtonContainer}>
          <button className={styles.topButton} onClick={scrollToTop}>
            {intl.t('review.howWeRate.backToTop')}
            <Image
              className={styles.closeIcon}
              src='/assets/icons/icon-white-arrow-up.svg'
              width='15'
              height='15'
              alt='Open arrow'
            />
          </button>
        </div>
        {/* {headerLoaded && (
          <div className={styles.footer}>
            <Footer />
          </div>
        )} */}
      </div>
    </>
  )
}

const NewsletterLayout = ({ children }) => {
  // const intl = useAppIntl()

  return (
    <BaseLayout
      scrollInContent
      seo={{
        title: 'Crypto Market Insights: Weekly Newsletter',
        description:
          'Stay updated with COIN360s weekly newsletter. Get in-depth insights into the digital asset and blockchain world and browse our archive of market digests',
        canonical: `${WEBSITE}/newsletter`,
      }}
    >
      <Script src='https://js.hsforms.net/forms/embed/v2.js' />
      {children}
    </BaseLayout>
  )
}

Newsletter.getLayout = NewsletterLayout
